import type { ClientKind } from '@/kinds/kind'
import { apply, defaults, displayName, initialStatus, validate } from './apply'
import { dateSpec, dateStatus, type DateSpec, type DateStatus } from './schema'

const Nothing = () => null

/** Dates are shown by views/Dates.tsx and the Today, Upcoming and Calendar lines. */
export const dateKind: ClientKind<DateSpec, DateStatus> = {
  name: 'Date',
  version: 1,
  spec: dateSpec,
  status: dateStatus,
  defaults,
  validate,
  initialStatus,
  displayName,
  apply,
  actions: [],
  ListRow: Nothing,
  Detail: Nothing,
  Form: Nothing,
  workspaceScoped: false,
}

export * from './schema'
export type { DateResource } from './apply'
